import { render } from "./FeaturedJobs.vue?vue&type=template&id=56719670&scoped=true"
import script from "./FeaturedJobs.vue?vue&type=script&lang=js"
export * from "./FeaturedJobs.vue?vue&type=script&lang=js"

import "./FeaturedJobs.vue?vue&type=style&index=0&id=56719670&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56719670"]])

export default __exports__